import {userActionTypes} from '../_constants';
import {authenticationState} from "../_constants/commons/authenticationState";
import {stateInitializer} from "./stateInitializer";

// initial state for the reducer
const initialState = stateInitializer.getAuthInitialStates();

/**
 * User-Authentication redux reducer that sets appropriate user states
 * @param state
 * @param action
 * @returns {{newUser: *, creatingAccount: boolean}|{}|{createdAccount: boolean, newUser: *}|*}
 */
export function authentication(state = initialState, action) {
    switch (action.type) {

        // user creation process start
        case userActionTypes.CREATE_USER_REQUEST:
            return {
                authState: authenticationState.CREATING_ACCOUNT,
                newUser: action.user.email
            };

        // user creation process success
        case userActionTypes.CREATE_USER_SUCCESS:
            return {
                authState: authenticationState.CREATED_ACCOUNT,
                newUser: action.user.email
            };

        // user creation process failure
        case userActionTypes.CREATE_USER_FAILURE:
            return {
                authState: authenticationState.NOT_LOGGED_IN
            };

        // login request
        case userActionTypes.LOGIN_REQUEST:
            return {
                authState: authenticationState.LOGGING_IN,
                user: action.user
            };

        // login successful
        case userActionTypes.LOGIN_SUCCESS:
            return {
                authState: authenticationState.LOGGED_IN,
                user: action.user
            };

        // login failure
        case userActionTypes.LOGIN_FAILURE:
            return {
                authState: authenticationState.NOT_LOGGED_IN
            };

        default:
            return state;
    }
}